import { SignupContextProvider } from 'user/signup/context/signup-context'

import { Routes } from './routes'

const App = ({ isCaptchaEnabled, captchaKey, isNewHeaderEnabled }) => (
  <SignupContextProvider
    isCaptchaEnabled={isCaptchaEnabled === 'true'}
    captchaKey={captchaKey}
  >
    <Routes isNewHeaderEnabled={isNewHeaderEnabled} />
  </SignupContextProvider>
)

export default App
